export function isoToDatePart(iso: string): string | null {
  if (typeof iso !== 'string' || iso.length < 10) return null;
  const date = iso.slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(date) ? date : null;
}

export function isoToTimeHHMM(iso: string): string | null {
  if (typeof iso !== 'string' || iso.length < 16) return null;
  const time = iso.slice(11, 16);
  return /^\d{2}:\d{2}$/.test(time) ? time : null;
}
